import React, { Suspense, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import CustomLoader from "../shared-components/Loader";
import { customeRoutes } from "./lazy-load";
import { INVALID_URL, LEFT_NAVIGATION_PAGE_URL, PAGE_TYPE, USER_PRIVILEGE } from "../models/navigation.models";
import InvalidUrl from "../shared-components/invalid-url/InvalidUrl";
import AccessDenied from "../shared-components/access-denied/AccessDenied";
import { checkUserPermissionOnPage, encrypt } from "../helpers/util-common";
import { setselectedWITN } from "../workitem.actions";
import commonActions from "../common.actions";
import { getWIDetailOnWITN, getWorkItemsAction } from "../redux/action/workItem";
import { COMMON_LABELS } from "../../common.enum";

type Option = {
  text: string;
  value: string;
  key: string;
};
interface Props {
  defaultUrl?: any;
  isUserAuthorized: any;
  isLoginByAzureAD?: any;
  userDetail?: any;
  history?: any;
  ballotStatusOption: Option[];
  wiStatusOption: Option[];
  quickSearchSelectedUser: string;
  updateQuickSearchUser: () => void;
  currentAction: string;
  setCurrentAction: any;
  setIsUserOfficer: (flag: boolean) => void;
  isUserOfficer: any;
  committeeData: any;
  setGlobalSearchReset: () => void;
  searchFlow: string;
  allCommittees: any[];
  permission:any;
}
const Navigation: React.FC<Props> = (props: Props) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [invalidUrl, setInvalidUrl] = useState(false);
  const userPermission = useSelector((state: any) => state.commonReducer.userPermission);
  const overLayLoader = useSelector((state: any) => state.commonReducer.overLayLoader);
  const witn = searchParams.get("WITN");
  const auditLogWITN = searchParams.get("auditLogWITN")
  const deletedWI = searchParams.get("deletedWI");
  const selectedWI = searchParams.get("selectedWI");
  const getWILink = (witn: string) => {
      const dataToEncrypt = {
        FormattedStandardDesignation: null,
        DisplayDesignationNumber: null,
        StandardDesignationMetric: null,
      };
      getWIDetailOnWITN(dispatch, witn, (response: any) => {
        if (response) {
          const encryptedData = encrypt(JSON.stringify(dataToEncrypt));
          const WorkItemNumber = response?.WorkItemNumber;
          let detailUrl= `${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${encrypt(`${response?.WorkItemId}`)}/${response?.WorkItemCategory}/${WorkItemNumber}?standardDesignationPageInfo=${encryptedData}&WITN=${witn}`
          if(detailUrl){
            navigate(detailUrl);
          }
        } else {
          dispatch(commonActions.setMessage(true,"9189"));
          navigate(INVALID_URL.PAGE_NOT_FOUND)
        }
      })
    }
  const navigationFromQueryParams = () => {
    if (auditLogWITN && checkUserPermissionOnPage(userPermission,PAGE_TYPE.WITN,USER_PRIVILEGE.VIEW)) {
      getWILink(auditLogWITN);
    } else if (witn && checkUserPermissionOnPage(userPermission,PAGE_TYPE.WITN,USER_PRIVILEGE.VIEW)) {
      dispatch(setselectedWITN(witn));
      navigate(location.pathname);
    } else if (deletedWI) {
      navigate(location.pathname);
      dispatch(commonActions.showSuccessToastMesage(true, "", `Work Item ${deletedWI} successfully deleted!`));
    }else if(selectedWI){
      const data = {"WorkItemIds": [],"WorkItemNumbers":[selectedWI]}
      getWorkItemsAction(data,dispatch,(response)=>{
        if(response.length > 0){
          const selectedWIN = response && response.find(
            (item) => item.WorkItemNumber.toString() === selectedWI.toUpperCase().replace(item.WorkItemCategory, '')
          );
          const urlParams = new URLSearchParams(window.location.search);
          const navigationUrl = urlParams?.get('standardDesignationPageInfo') 
            ? `${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${encrypt(`${selectedWIN.WorkItemId}`)}/${selectedWIN.WorkItemCategory}/${selectedWIN.WorkItemNumber}?standardDesignationPageInfo=${urlParams.get('standardDesignationPageInfo')}`
            : `${LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL}/${encrypt(`${selectedWIN.WorkItemId}`)}/${selectedWIN.WorkItemCategory}/${selectedWIN.WorkItemNumber}`
          navigate(navigationUrl);
        }
        else if(response.length ===0){
          dispatch(commonActions.setMessage(true,"9075"));
          navigate(INVALID_URL.PAGE_NOT_FOUND)
        }
      })
    }
  }

  useEffect(() => {
    if (location.pathname === LEFT_NAVIGATION_PAGE_URL.REDIRECT_URL && !auditLogWITN && !selectedWI) {
      navigate(INVALID_URL.PAGE_NOT_FOUND);
    }
    const validPaths = Object.values(LEFT_NAVIGATION_PAGE_URL);
    setInvalidUrl(validateUrl(validPaths));
    navigationFromQueryParams();
  }, [location, userPermission]);
  const validateUrl = (validPaths: string[]) => {
    if (location?.pathname?.length) {
      const path = location.pathname.split("/")[1];
      return validPaths.indexOf("/" + path) === -1;
    }
  };
  return (
    props.permission  && 
    <div className="btapp-container container-fluid">
      <Suspense fallback={<CustomLoader hasOverlay={overLayLoader} />}>
        {/* This code will be removed when the permissions are added in the code */}
        { !invalidUrl ? (
          <Routes>
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW) ? (<Route path={LEFT_NAVIGATION_PAGE_URL.BALLOTS} element={<customeRoutes.Ballots
              overLayLoader={overLayLoader}
              ballotStatusOption={props.ballotStatusOption}
              quickSearchSelectedUser={props.quickSearchSelectedUser}
              updateQuickSearchUser={props.updateQuickSearchUser}
              currentAction={props.currentAction}
              setCurrentAction={props.setCurrentAction}
              setIsUserOfficer={props.setIsUserOfficer}
              isUserOfficer={props.isUserOfficer}
              setGlobalSearchReset={props.setGlobalSearchReset}
              searchFlow={props.searchFlow}
            />} />) : (
              <Route path={LEFT_NAVIGATION_PAGE_URL.BALLOTS} element={<AccessDenied />} />
            )}
            <Route path={LEFT_NAVIGATION_PAGE_URL.DASHBOARD} element={<customeRoutes.DashBoard />} />
            {(checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW)) ? (<Route path={LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS + "/:ballotId"} element={<customeRoutes.BallotDetails committeeData={props.committeeData} />} />) : (
              <Route path={LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILS + "/:ballotId"} element={<AccessDenied />} />
              )}
            {(checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW)) ? (<Route path={LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT + "/:itemNumber/:ballotId"} element={<customeRoutes.NegativeCommentsReview />} />) : (
              <Route path={LEFT_NAVIGATION_PAGE_URL.BALLOT_ITEM_DETAIL_RESULT + "/:itemNumber/:ballotId"} element={<AccessDenied />} />
            )}
            {(checkUserPermissionOnPage(userPermission,PAGE_TYPE.BALLOT,USER_PRIVILEGE.VIEW)) ? (<Route path={LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE + "/:itemNumber/:ballotNegativeId/:ballotId"} element={<customeRoutes.NegativeCommentsRulingRationale />} />) : (
              <Route path={LEFT_NAVIGATION_PAGE_URL.VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE} element={<AccessDenied />} />
            )}
            {checkUserPermissionOnPage(userPermission, PAGE_TYPE.BT_BALLOT_QUEUE, USER_PRIVILEGE.VIEW) ?
            <Route path={LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS + "/:ballotId" } element={<customeRoutes.BallotDetailsAddItems 
              setGlobalSearchReset={props.setGlobalSearchReset}
              committeeData={props.allCommittees}
            />} />
            : <Route path={LEFT_NAVIGATION_PAGE_URL.BALLOTDETAILSADDITEMS  + "/:ballotId"} element={<AccessDenied />} />}
            {checkUserPermissionOnPage(userPermission, PAGE_TYPE.BT_BALLOT_QUEUE, USER_PRIVILEGE.VIEW)
            ? <Route path={LEFT_NAVIGATION_PAGE_URL.GLOBALBALLOTQUEUE} element={<customeRoutes.BallotDetailsAddItems 
              setGlobalSearchReset={props.setGlobalSearchReset}
              flow={COMMON_LABELS.GLOBAL}
              committeeData={props.allCommittees}
            />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.GLOBALBALLOTQUEUE} element={<AccessDenied />} />}
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEM} element={<customeRoutes.WorkItem />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEM} element={<AccessDenied />} />}
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG} element={<customeRoutes.WorkItemAudigLog />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEM_AUDITLOG} element={<AccessDenied />} />}
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.WORK_ITEM,USER_PRIVILEGE.VIEW) ?  <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEM} element={<customeRoutes.WorkItem  currentAction={props.currentAction}
              setCurrentAction={props.setCurrentAction}  setGlobalSearchReset={props.setGlobalSearchReset}
              /> }   
             /> : <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEM} element={<AccessDenied />} />}
            {checkUserPermissionOnPage(userPermission, PAGE_TYPE.WORK_ITEM, USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL + "/:workItemId" + "/:workItemCategory" + "/:workItemNumber"} element={<customeRoutes.WorkItemDetail />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL + "/:workItemId" + "/:workItemCategory" + "/:workItemNumber"} element={<AccessDenied />} />}
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.ANSI_DETAILS,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.MANAGE_ANSI_COMMITTEE_STANDARD} element={<customeRoutes.ManageAnsiCommittee />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.MANAGE_ANSI_COMMITTEE_STANDARD} element={<AccessDenied />} />}  
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.ANSI_DETAILS,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR108} element={<customeRoutes.ManageBSR108 />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR108} element={<AccessDenied />} />}  
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.ANSI_DETAILS,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR109} element={<customeRoutes.ManageBSR109 />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.MANAGE_BSR109} element={<AccessDenied />} />}  
            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.ANSI_DETAILS,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.PINS_REPORTS} element={<customeRoutes.PINSReports />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.PINS_REPORTS} element={<AccessDenied />} />}  

            {checkUserPermissionOnPage(userPermission,PAGE_TYPE.ANSI_DETAILS_AUDIT_LOG,USER_PRIVILEGE.VIEW) ? <Route path={LEFT_NAVIGATION_PAGE_URL.ANSI_AUDIT_LOG} element={<customeRoutes.AnsiAuditLog />} /> : <Route path={LEFT_NAVIGATION_PAGE_URL.ANSI_AUDIT_LOG} element={<AccessDenied />} />}  
            <Route path="/" element={<></>} />
            <Route path="*" element={<customeRoutes.Invalid />} />
            <Route path={LEFT_NAVIGATION_PAGE_URL.REDIRECT_URL} element={<></>} />
          </Routes>
        ) : (
          <InvalidUrl />
        )}
      </Suspense>
    </div>
  );
};

export default Navigation;
